import { render } from "./region-update.vue?vue&type=template&id=79e87eed"
import script from "./region-update.vue?vue&type=script&lang=js"
export * from "./region-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__